const IMAGE_DATA_URL_PREFIX = 'data:image/';

/**
 * Returns true if the cached entry contains a valid base64 image data URL for the given URL.
 *
 * @param {{ url: string, dataUrl: string } | null} entry - Parsed cache entry.
 * @param {string} url - The logo URL to match against.
 * @returns {boolean}
 *
 * @example
 * isValidLogoEntry({ url: 'https://example.com/logo.png', dataUrl: 'data:image/png;base64,...' }, 'https://example.com/logo.png')
 * // => true
 */
export const isValidLogoEntry = (entry, url) => {
    return entry?.url === url && entry?.dataUrl?.startsWith(IMAGE_DATA_URL_PREFIX);
};

/**
 * Returns true if the given data URL represents a valid image.
 *
 * @param {string} dataUrl
 * @returns {boolean}
 *
 * @example
 * isImageDataUrl('data:image/jpeg;base64,...') // => true
 * isImageDataUrl('data:text/html;base64,...')  // => false
 */
export const isImageDataUrl = (dataUrl) => {
    return dataUrl?.startsWith(IMAGE_DATA_URL_PREFIX);
};
